module.exports = __webpack_public_path__ + "img/37.14b256d4.png";